import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { SparklesIcon, DownloadIcon, ShieldCheckIcon } from 'lucide-react';
export function CTASection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section id="cta-final" ref={ref} className="w-full gradient-purple py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-10">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10" data-id="element-11">
        <div className="absolute top-10 right-10 w-40 h-40 rounded-full bg-white/20 moon-glow" data-id="element-12" />
        <div className="absolute bottom-20 left-20 w-32 h-32 rounded-full bg-white/15" data-id="element-13" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-15">
          <div className="mb-6" data-id="element-16">
            <div className="inline-block bg-coral/20 backdrop-blur-sm rounded-full px-6 py-3 mb-4" data-id="element-17">
              <p className="text-white text-lg font-semibold" data-id="element-18">
                🔥 Oferta Especial - ¡Ahorra 62%!
              </p>
            </div>
            <div className="flex items-center justify-center gap-4 mb-4" data-id="element-19">
              <span className="text-lavender-light text-3xl sm:text-4xl font-bold line-through opacity-60" data-id="element-20">
                $17.00
              </span>
              <span className="text-white text-5xl sm:text-6xl md:text-7xl font-bold font-heading text-shadow-soft" data-id="element-21">
                $6.39
              </span>
            </div>
            <p className="text-cream text-xl font-semibold" data-id="element-22">ZIP instantáneo</p>
          </div>

          <p className="text-lavender-light text-2xl sm:text-3xl font-heading font-semibold mb-12" data-id="element-23">
            Empieza noche de hoy —despierta controlada.
          </p>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={isInView ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="mb-12" data-id="element-24">
            <button onClick={() => window.open('https://guiafaseslunares.com/cart/46429443555517:1', '_blank')} className="group relative px-12 py-6 bg-coral hover:bg-terracotta text-white text-2xl font-bold rounded-full shadow-2xl transition-all duration-300 hover:scale-105 hover:shadow-[0_0_40px_rgba(251,113,133,0.6)]" data-id="element-25">
              <span className="flex items-center gap-4" data-id="element-26">
                <SparklesIcon className="w-8 h-8" data-id="element-27" />
                COMPRAR AHORA - Solo $6.39
              </span>
            </button>
            <p className="text-lavender-light/80 text-sm mt-4" data-id="element-28">
              ⏰ Precio especial por tiempo limitado
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="flex flex-col sm:flex-row items-center justify-center gap-8 text-lavender-light" data-id="element-29">
            <div className="flex items-center gap-3" data-id="element-30">
              <DownloadIcon className="w-6 h-6" data-id="element-31" />
              <span className="text-lg" data-id="element-32">Descarga en segundos</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-33">
              <ShieldCheckIcon className="w-6 h-6" data-id="element-34" />
              <span className="text-lg" data-id="element-35">Pago seguro</span>
            </div>
          </motion.div>

          <motion.p initial={{
          opacity: 0
        }} animate={isInView ? {
          opacity: 1
        } : {}} transition={{
          duration: 0.8,
          delay: 0.9
        }} className="text-lavender-light text-xl sm:text-2xl font-heading font-semibold mt-12" data-id="element-36">
            Duerme mejor esta noche. Tu menopausia no manda más.
          </motion.p>
        </motion.div>
      </div>
    </section>;
}